import * as Yup from 'yup';

export const newLeadSchema = Yup.object({
  email_address: Yup.string().email().required('Please provide an email address'),
  collateral: Yup.array()
    .of(
      Yup.object().shape({
        make: Yup.object().required(),
        model: Yup.object().required(),
        selling_price: Yup.number().required('Please provide a selling price'),
        year: Yup.number(),
        color: Yup.string(),
        condition: Yup.object().required('Please provide a condition'),
        asset_class: Yup.object().required('Please provide an asset class'),
        title: Yup.string(),
      }),
    )
    .required('Please select a collateral'),
});
